import EntityType from "@mapmycustomers/shared/enum/EntityType";
import Identified from "@mapmycustomers/shared/types/base/Identified";
import TypedEntity from "@mapmycustomers/shared/types/base/TypedEntity";
import { AnyEntity } from "@mapmycustomers/shared/types/entity";

const applyEmailObjectsChanges = <T extends Identified & TypedEntity<EntityType>>({
  changedObjectsType,
  deletedObjectIds,
  objects,
  objectsTypes,
  restoredObjects,
  updatedObjects,
  usingObjectIds,
}: {
  changedObjectsType: EntityType;
  deletedObjectIds?: AnyEntity["id"][];
  objects: T[];
  objectsTypes: EntityType[];
  restoredObjects?: AnyEntity[];
  updatedObjects?: AnyEntity[];
  usingObjectIds?: T["id"][];
}): T[] => {
  if (!objectsTypes.includes(changedObjectsType)) {
    return objects;
  }

  let result = objects;

  if (deletedObjectIds) {
    result = result.filter(
      (object) => object.entity === changedObjectsType && !deletedObjectIds!.includes(object.id)
    );
  }

  if (updatedObjects) {
    result = result.map(
      (object) =>
        (updatedObjects!.find(
          (updatedObject) =>
            updatedObject.entity === object.entity && updatedObject.id === object.id
        ) as unknown as T | undefined) ?? object
    );
  }

  if (restoredObjects) {
    const usingObjectIdsSet = new Set(usingObjectIds ?? []);
    const restoredRelevantObjects = restoredObjects.filter((restoredObject) =>
      usingObjectIdsSet.has(restoredObject.id)
    );
    result.push(...(restoredRelevantObjects as unknown as T[]));
  }

  return result;
};

export default applyEmailObjectsChanges;
